import React, { useState, useEffect } from 'react';
import { StyleSheet, Animated } from 'react-native';

const AnimatedCard = ({ 
  children, 
  style, 
  delay = 0,
  enableHover = false, // Disabled by default - no grow on hover
  ...props 
}) => {
  const [fadeAnim] = useState(new Animated.Value(0));

  useEffect(() => {
    // Fade in on mount
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 400,
      delay,
      useNativeDriver: true,
    }).start();
  }, [delay, fadeAnim]);

  return (
    <Animated.View
      style={[
        styles.card,
        {
          opacity: fadeAnim,
        },
        style,
      ]}
      {...props}
    >
      {children}
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  card: {
    // No hover transform styles needed
  },
});

export default AnimatedCard;

